import { render, staticRenderFns } from "./OrganisationPlansModule.vue?vue&type=template&id=74360894&"
import script from "./OrganisationPlansModule.vue?vue&type=script&lang=js&"
export * from "./OrganisationPlansModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports